import $ from '../lib/jquery';
import './owl-carousel-2.1.6';

/**
 * OuterStage Plugin
 * @version 1.0.0
 * @author Zheng Luo (zheng.luo@neuland-bfi.de)
 *
 * Sets a fixed width on the outer stage of the carousel.
 * This is a workaround to clip the viewable area because of rounding errors when scaling the viewport width.
 */
'use strict';

/**
 * Creates the OuterStage plugin.
 * @class The OuterStage Plugin
 * @param {Owl} scope - The Owl Carousel
 */
export const Outerstage = function (carousel) {
  /**
   * Reference to the core.
   * @protected
   * @type {Owl}
   */
  this._core = carousel;

  /**
   * All event handlers.
   * @protected
   * @type {Object}
   */
  this._handlers = {
    'refreshed.owl.carousel': $.proxy(function (e) {
      if (this._core.options.clipOuterstageToItem) {
        this.clipOuterstageToItem();
      }
    }, this)
  };

  // register event handlers
  this._core.$element.on(this._handlers);

  // set default options
  this._core.options = $.extend({}, Outerstage.Defaults, this._core.options);
};

/**
 * Default options.
 * @public
 */
Outerstage.Defaults = {
  clipOuterstageToItem: false
};

/**
 * Clips the outer stage
 */
Outerstage.prototype.clipOuterstageToItem = function () {
  var itemWidth = this._core._widths[0];
  this._core.$stage.parent()
    .css({ 'max-width': itemWidth + 'px' });
};

/**
 * Destroys the plugin.
 */
Outerstage.prototype.destroy = function () {
  var handler,
    property;

  for (handler in this._handlers) {
    this._core.$element.off(handler, this._handlers[handler]);
  }

  for (property in Object.getOwnPropertyNames(this)) {
    typeof this[property] != 'function' && (this[property] = null);
  }
};

$.fn.owlCarousel.Constructor.Plugins.Outerstage = Outerstage;
